import React from 'react'
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'

import { formatNumber } from './numberFormatting'
import dateTimeFields from './constants/widgets/dateTimeFields'

const transform = (node, index) => {
    if (node.name === 'a') {
        if (
            node.attribs.href.includes('http') ||
            node.attribs.href.includes('www') ||
            node.attribs.href.includes('javascript')
        ) {
            return convertNodeToElement(node, index, transform)
        } else {
            return (
                <Link className="internalLink" to={node.attribs.href}>
                    {convertNodeToElement(node, index, transform)}
                </Link>
            )
        }
    } else {
        return convertNodeToElement(node, index, transform)
    }
}

const formatValue = (value, col) => {
    if (typeof value !== 'undefined' && value !== null && `${value}`.trim() !== '') {
        if (isNaN(value)) {
            if (dayjs(value).isValid()) {
                const isTime = dateTimeFields.includes(col)
                return dayjs(value)
                    .format(isTime ? 'MM/DD/YYYY HH:mm:ss' : 'MM/DD/YYYY')
                    .toString()
            } else {
                return ReactHtmlParser(value, { transform })
            }
        } else {
            return formatNumber(value)
        }
    } else {
        return null
    }
}

const formatValueExport = (value, col) => {
    if (typeof value !== 'undefined' && value !== null) {
        if (isNaN(value)) {
            if (dayjs(value).isValid()) {
                const isTime = dateTimeFields.includes(col)
                return dayjs(value)
                    .format(isTime ? 'MM/DD/YYYY HH:mm:ss' : 'MM/DD/YYYY')
                    .toString()
            } else {
                var val = ReactHtmlParser(value, { transform })
                if (Array.isArray(val) && val.length === 1) {
                    val = val[0]
                }
                return val
            }
        } else {
            return formatNumber(value)
        }
    } else {
        return null
    }
}

const formatValueExportReport = (value) => {
    if (typeof value === 'undefined' || value === null) {
        return null
    }

    if (isNaN(value) && dayjs(value).isValid()) {
        return dayjs(value).format('YYYY-MM-DD HH:mm:ss.SSS').toString()
    } else {
        return value
    }
}

//if it's not a valid date (i.e null) set the date to an absurdly high value so they get filtered to the bottom in no particular order https://stackoverflow.com/questions/60907412/how-to-sort-array-by-date-when-some-dates-are-null
// https://stackoverflow.com/questions/28993107/momentjs-how-to-prevent-invalid-date
const formatDate = (value, isTime) =>
    dayjs(value).isValid()
        ? dayjs(value).format(isTime ? 'MM/DD/YYYY HH:mm:ss' : 'MM/DD/YYYY')
        : dayjs('1/1/1002').format('MM/DD/YYYY')

export default formatValue
export { formatDate, formatValueExport, formatValueExportReport }
